import PLDProvider from './context/pld-context';
import {useState} from 'react';
import {PLD, AUTO_NUEVO, AUTO_USADO, ESTUDIOS, HIPOTECARIO} from './components/Utilitario';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import loadable from "@loadable/component";
const Inicio =  loadable(() => import(/* webpackChunkName: "Inicio" */ "../src/pages/Inicio"));
const HipotecarioPage =  loadable(() => import(/* webpackChunkName: "HipotecarioPage" */ "../src/pages/HipotecarioPage/HipotecarioFirstStep"));
const HipotecarioSecondPage =  loadable(() => import(/* webpackChunkName: "HipotecarioSecondPage" */ "../src/pages/HipotecarioPage/HipotecarioSecondStep"));
const HipotecarioThirdPage =  loadable(() => import(/* webpackChunkName: "HipotecarioThirdPage" */ "../src/pages/HipotecarioPage/HipotecarioThirdStep"));
const HipotecarioFourthPage =  loadable(() => import(/* webpackChunkName: "HipotecarioFourthPage" */ "./pages/HipotecarioPage/HipotecarioFourthStep"));
const LoadProcesando =  loadable(() => import(/* webpackChunkName: "LoadProcesando" */ "../src/pages/Loading/LoadProcesando"));
const Simulador =  loadable(() => import(/* webpackChunkName: "Simulador" */ "../src/pages/Simulador"));
const Contratar =  loadable(() => import(/* webpackChunkName: "Contratar" */ "../src/pages/Contratar"));
const Error =  loadable(() => import(/* webpackChunkName: "Error" */ "../src/pages/Error"));
const Final =  loadable(() => import(/* webpackChunkName: "Final" */ "../src/pages/Final"));
const DireccionOcupacion =  loadable(() => import(/* webpackChunkName: "DireccionOcupacion" */ "../src/pages/DireccionOcupacion"));
const Evaluacion =  loadable(() => import(/* webpackChunkName: "Evaluacion" */ "../src/pages/Evaluacion/Evaluacion"));
const OfertaAprobada = loadable(() => import(/* webpackChunkName: "OfertaAprobada" */ "../src/pages/OfertaAprobada/OfertaAprobada"));
const SuccessOtros = loadable(() => import(/* webpackChunkName: "SuccessOtros" */ "../src/pages/SuccessOtros/SuccessOtros"));
const Crossell =  loadable(() => import(/* webpackChunkName: "Crossell" */ "../src/pages/Crossell"));

function App() {
  const [state] = useState({
    contextSPA: obtenerContext('SPA'),
    contextAjax: obtenerContext('AJAX'),
  });

  function obtenerContext(value) {
    const inProd = obtenerURLHost();
    const contextParent= window.location.pathname;
    
    const pathAplicacion = contextParent.split('/')[1];
    if (value === 'SPA') {
      return inProd ? '' : `/${pathAplicacion}`;
    } else {
      return inProd ? '/' : `/${pathAplicacion}/`;
    }
  }

  function obtenerURLHost() {
    return window.location.host === 'prestamos.bbva.pe';
  }

  return (
    <PLDProvider>
      <Router>
        <Route path={`${state.contextSPA}/final`} render={(props) => <Final {...props} />} />
        <Route path={`${state.contextSPA}/error`} render={(props) => <Error {...props} />} />
        <Route
          path={`${state.contextSPA}/prestamos-personales`}
          render={(props) => <Inicio {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={PLD} />}
        />
        <Route
          path={`${state.contextSPA}/credito-hipotecario`}
          render={(props) => <HipotecarioPage {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={HIPOTECARIO} />}
        />
        <Route
          path={`${state.contextSPA}/credito-hipotecario-simulador`}
          render={(props) => <HipotecarioSecondPage {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={HIPOTECARIO} />}
        />
        <Route
          path={`${state.contextSPA}/credito-hipotecario-resumen`}
          render={(props) => <HipotecarioThirdPage {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={HIPOTECARIO} />}
        />
        <Route
          path={`${state.contextSPA}/credito-hipotecario-constancia`}
          render={(props) => <HipotecarioFourthPage {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={HIPOTECARIO} />}
        />
        <Route
          path={`${state.contextSPA}/credito-vehicular-nuevo`}
          render={(props) => <Inicio {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={AUTO_NUEVO} />}
        />
        <Route
          path={`${state.contextSPA}/credito-vehicular-seminuevo`}
          render={(props) => <Inicio {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={AUTO_USADO} />}
        />
        <Route
          path={`${state.contextSPA}/credito-estudiantil`}
          render={(props) => <Inicio {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={ESTUDIOS} />}
        />
        <Route
          path={`${state.contextSPA}/procesando`}
          render={(props) => <LoadProcesando {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} />}
        />
        <Route
          path={`${state.contextSPA}/simulador`}
          render={(props) => <Simulador {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={PLD} />}
        />
        <Route
          path={`${state.contextSPA}/contratar`}
          render={(props) => <Contratar {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} perfil={PLD} />}
        />
        <Route
          path={`${state.contextSPA}/direccion`}
          render={(props) => <DireccionOcupacion {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} />}
        />
        <Route
          path={`${state.contextSPA}/evaluacion`}
          render={(props) => <Evaluacion {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA}/>}/>
        <Route
          path={`${state.contextSPA}/oferta-aprobada`}
          render={(props) => <OfertaAprobada {... props} contextBack={state.contextAjax} contextSPA={state.contextSPA} />}/>
        <Route
          path={`${state.contextSPA}/felicidades`}
          render={(props) => <SuccessOtros {...props} contextBack={state.contextAjax} contextSPA={state.contextSPA} />} />
        <Route 
          path={`${state.contextSPA}/crossell`} 
          render={(props) => <Crossell {...props} perfil={PLD}/>} />  
      </Router>
    </PLDProvider>
  );
}

export default App;